<template>
  <div>
    <el-dialog
      title="选择实物奖品"
      :visible.sync="dialogVisible"
      width="1100px"
      center
      @close="dialogClose"
    >
      <el-form ref="objectForm" :model="objectForm" label-width="74px">
        <el-form-item label="奖品来源:">
          <el-radio-group
            v-model="objectForm.resource"
            @change="changeResource"
          >
            <el-radio :label="2">直接填写</el-radio>
            <el-radio :label="1">从店铺中选择</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-show="objectForm.resource == 2">
          <el-upload
            ref="upload"
            action="#"
            list-type="picture-card"
            :on-change="handleChange"
            :on-remove="handleRemove"
            :http-request="httpRequest"
            :file-list="fileList"
          >
            <i class="el-icon-plus"></i>
          </el-upload>

          <span style="color: #7B61FF; font-size: 12px"
            >建议尺寸：200*200像素，图片大小不能超过300K，类型：JPG、PNG</span
          >
        </el-form-item>
        <el-form-item v-if="objectForm.resource == 1">
          <div v-if="objectForm.logo && objectForm.resource == 1">
            <img
              :src="objectForm.logo"
              alt=""
              style="width: 150px; height: 150px"
            />
          </div>
          <el-button @click="dialogFormVisible = true" style="width: unset;"
            >选择店铺商品</el-button
          >
        </el-form-item>
        <el-form-item label="奖品名称:">
          <el-input
            v-model="objectForm.name"
            maxlength="20"
            show-word-limit
            style="width: 320px"
          ></el-input>
        </el-form-item>
        <el-form-item label="奖品价值:">
          <el-input
            v-model="objectForm.discount"
            @input="objectForm.discount = getNumberData(1, $event, 1, 0)"
            style="width: 320px"
          ></el-input>
          <span> 元/件</span>
        </el-form-item>
        <el-form-item style="margin-left: -74px;">
          <el-button type="primary" style="width: 180px" @click="changeJP()"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 选择商品弹窗 -->
    <el-dialog title="选择商品" :visible.sync="dialogFormVisible" width="820px">
      <input-form
        style="margin: 20px 0"
        :inputData="commodityList"
        @toParentVal="searchContent"
        :immediately="true"
      ></input-form>
      <el-table
        :data="tableShopData"
        stripe
        style="width: 90%; margin: 0 auto"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
      >
        <el-table-column width="100">
          <template slot-scope="scope">
            <img
              :src="scope.row.logo"
              class="avar"
              alt="商品图片"
              style="height: 60px; width: 60px"
            />
          </template>
        </el-table-column>
        <el-table-column prop="skuName" label="商品名称" width="300">
          <template slot-scope="scope">
            <a :href="scope.row.itemUrl" target="_blank"
              >{{ scope.row.skuName }}<br />
              ¥{{ scope.row.jdPrice }}</a
            >
            <!-- <span>{{ scope.row.skuName }}</span
            ><br />
            <span>¥{{ scope.row.jdPrice }}</span> -->
          </template>
        </el-table-column>
        <el-table-column prop="skuId" label="SKU ID" width="200">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="chooseShop(scope.row)"
              v-loading="sureLoading"
              style="width: 50px"
              >选择</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin: 40px 80px 0 0; text-align: right"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="formShopList.current"
        :page-sizes="[5, 10, 30, 50, 100]"
        :page-size="formShopList.size"
        layout="total, sizes, prev, pager, next, jumper"
        class="pagination"
        :total="totalListThr"
      ></el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import inputForm from "../../components/inputForm";
import SelectGoods from "../../components/selectGoodsMonitor";
import { mapState } from "vuex";
import {
  getTaobaoItemListSku,
  getSellercats,
} from "@/api/analysis/ware-controller.js";
import { uploadpic } from "@/api/paradiseAndTaskCommonController.js";
import { checkProduct } from "@/api/integralCenter/prizeCenter.js";

export default {
  name: "selectGoodsGift",
  components: {
    inputForm,
    SelectGoods,
  },
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    // 回显的数据
    echoDate: {
      type: Object,
    },
  },
  computed: {
    ...mapState(["venderType"]),
  },
  watch: {
    async dialogVisible(news) {
      // 回显
      if (news) {
        console.log("this.echoDate", this.echoDate);
        this.init();
        this.objectForm.discount = this.echoDate.price;
        this.objectForm.name = this.echoDate.title;
        this.objectForm.logo = this.echoDate.logo;
        this.objectForm.resource =
          this.echoDate.assetsId || !this.objectForm.logo ? 1 : 2;
        if (this.objectForm.resource == 2 && this.objectForm.logo) {
          this.fileList = [
            {
              url: this.echoDate.logo,
              name: this.echoDate.title,
            },
          ];
        } else {
          this.fileList = [];
        }
        if (this.objectForm.resource == 2) {
          this.$nextTick(() => {
            if (this.fileList.length < 1) {
              this.$refs.upload.$children[1].$el.style.display = "inline-block";
            } else {
              this.$refs.upload.$children[1].$el.style.display = "none";
            }
          });
        }
      }
    },
  },
  data() {
    return {
      sureLoading: false,
      objectForm: {
        logo: "",
        resource: 1,
        name: "",
        discount: null,
      },
      fileList: [], // 上传图片数组
      dialogVisible: this.isShow, // 当前组件弹窗

      dialogFormVisible: false, // 选择店铺商品弹窗
      // 选择商品弹窗 表单
      commodityList: [
        {
          name: "商品类目:",
          placeholder: "请选择",
          val: "categoryId",
          cascaderArr: [],
          multiple: true,
          width: 240,
        },
        {
          name: "SKU ID:",
          val: "skuId",
          placeholder: "请输入SKU ID",
          isNumber: true,
          width: 240,
        },
        {
          name: "商品名称:",
          val: "skuName",
          placeholder: "请输入商品名称",
          width: 240,
        },
        {
          name: "商品状态:",
          val: "skuStatus",
          default: 1,
          selectArr: [
            { label: "全部", id: null },
            { label: "上架", id: 1 },
            { label: "下架", id: 2 },
          ],
          width: 136,
        },
      ],
      tableShopData: [], //  选择商品 列表
      totalListThr: 0, //  选择商品 列表总数
      formShopList: { current: 1, size: 5, skuStatus: 1 }, // 选择商品查询条件
    };
  },
  mounted() {
    this.getShopList();
    this.getSeller();
  },
  methods: {
    dialogClose() {
      this.$emit("close");
    },

    // 切换商品来源
    changeResource() {
      this.objectForm.skuId = null;
      this.objectForm.logo = "";
      this.objectForm.name = "";
      this.objectForm.discount = null;
      this.fileList = [];
      if (this.fileList.length < 1) {
        this.$refs.upload.$children[1].$el.style.display = "inline-block";
      }
    },
    // 获取店铺商品
    getShopList() {
      // this.formShopList;
      getTaobaoItemListSku(this.formShopList).then((res) => {
        this.tableShopData = res.data.records;
        this.totalListThr = Number(res.data.total);
        // console.log(res, 1111111111);
      });
    },
    // 获取商品类目
    getSeller() {
      getSellercats().then((res) => {
        let data = this.transverter(res.data);

        this.getTrees(data);

        // debugger
        let list = data.filter((item) => item.parent_id == 0);
        // console.log('list',list);
        let cascaderArr = list.map((item) => {
          return {
            label: item.label,
            value: item.value,
            children: item.children,
          };
        });

        this.commodityList[0].cascaderArr = cascaderArr;
      });
    },
    // 排重
    transverter(data) {
      let obj = {};
      for (let i = 0; i < data.length; i++) {
        obj[data[i]["categoryId"]] = data[i];
      }
      let arr = Object.values(obj);
      var newData = [];
      // console.log(arr);
      for (var i = 0; i < arr.length; i++) {
        newData[i] = {
          value: arr[i].categoryId,
          parent_id: arr[i].parentId,
          label: arr[i].name,
          isChecked: false,
        };
      }
      return newData;
    },
    // 商品数组结构转换
    getTrees(list, parent_id = 0) {
      let parentObj = {};
      list.forEach((o) => {
        parentObj[o.id] = o;
      });
      if (!parent_id) {
        return list
          .filter((o) => !parentObj[o.parent_id])
          .map((o) => {
            if (this.getTrees(list, o.value).length == 0) {
              // console.log(this.getTrees(list, o.value).length);
              delete o.children;
              return o;
            } else {
              return (o.children = this.getTrees(list, o.value)), o;
            }
          });
      } else {
        return list
          .filter((o) => o.parent_id == parent_id)
          .map((o) => {
            if (this.getTrees(list, o.value).length == 0) {
              // console.log(this.getTrees(list, o.value).length);
              delete o.children;
              return o;
            } else {
              return (o.children = this.getTrees(list, o.value)), o;
            }
          });
      }
    },
    //实物选择
    chooseShop(val) {
      console.log(val);
      const skuIds = [val.skuId];
      this.sureLoading = true;
      checkProduct(skuIds)
        .then((res) => {
          this.sureLoading = false;
          if (res.code == 1) {
            if (res.data.isHave) {
              this.$message.warning("活动暂不支持选择虚拟套装和影分身商品");
            } else {
              this.objectForm.logo = val.logo;
              this.objectForm.name = val.skuName.substr(0, 20);
              this.objectForm.discount = val.jdPrice;
              this.objectForm.skuId = val.skuId;
              this.objectForm.wareId = this.venderType ? val.skuId : val.wareId;
              this.dialogFormVisible = false;
            }
          } else {
            this.$message.warning(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
          this.sureLoading = false;
        });
      // this.objectForm.logo = val.logo;
      // this.objectForm.name = val.skuName.substr(0, 20);
      // this.objectForm.discount = val.jdPrice;
      // this.objectForm.skuId = val.skuId;
      // this.objectForm.wareId = this.venderType ? val.skuId : val.wareId;
      // this.dialogFormVisible = false;
    },
    searchContent(val) {
      this.formShopList.size = 5;
      this.formShopList.current = 1;
      if (val.categoryId) {
        this.formShopList.categoryId = val.categoryId.join(",");
      } else {
        this.formShopList.categoryId = "";
      }
      this.formShopList.skuId = val.skuId;
      this.formShopList.skuStatus = val.skuStatus;
      this.formShopList.skuName = val.skuName;
      this.getShopList();
    },

    //输入框限制负数
    checkputn(e) {
      let filtered = e.target.value.replace(/^0|[^\d]/g, "");
      e.target.value = Number(filtered);
      // //下边写用户输入时需要的执行逻辑
      // if(this.ruleForm.inputprize!= filtered) {
      //     this.ruleForm.inputprize = filtered
      // }
      // 不能输入0，绑定的值如果小于1，那么输入框置空
      if (e.target.value < 1) {
        e.target.value = "";
      }
    },
    //选择奖品弹窗
    openDialog() {
      this.dialogVisible = true;
    },

    // 初始化
    async init() {
      this.objectForm.resource = 1;
      this.objectForm.name = "";
      this.objectForm.discount = "";
      this.objectForm.logo = "";
      this.objectForm.skuId = this.echoDate.assetsId;
    },

    changeJP() {
      let zcData = {
        logo: this.objectForm.logo,
        couponId: this.objectForm.wareId,
        discount: this.objectForm.discount,
        name: this.objectForm.name,
        singleAmount: 1,
        skuId: this.objectForm.skuId,
      };
      if (this.objectForm.resource == 2) {
        delete zcData.skuId;
        delete zcData.couponId;
      }

      if (!zcData.logo) {
        if (this.objectForm.resource == 2) {
          this.$message.error("请上传奖品图片！");
          return false;
        } else {
          this.$message.error("请选择1个店铺商品！");
          return false;
        }
      }
      if (!zcData.name) {
        this.$message.error("请输入奖品名称！");
        return false;
      }
      if (!zcData.discount) {
        this.$message.error("请输入奖品价值！");
        return false;
      }

      this.dialogVisible = false;
      console.log(this.objectForm, "选择实物");
      this.$emit("choose-shop", zcData, 3);
    },
    httpRequest() {},
    //上传图片
    handleChange(file, fileList) {
      const isLt3M = file.size < 1024 * 300;
      if (!isLt3M) {
        this.$message.error("上传图片大小不能超过 300K");
        this.$refs.upload.clearFiles();
      } else {
        this.fileList = fileList;

        this.$refs.upload.$children[1].$el.style.display = "none";
        // this.objectForm.name = file.name;
        let formdata = new FormData();
        formdata.append("file", file.raw);
        uploadpic(formdata).then((res) => {
          // 获取图片真实url
          this.objectForm.logo = res.data;
        });
      }
    },

    // 移出图片
    handleRemove(file, fileList) {
      this.$refs.upload.$children[1].$el.style.display = "inline-block";
    },
    //分页事件
    handleSizeChange(val) {
      this.formShopList.size = val;
      this.getShopList();
    },
    handleCurrentChange(val) {
      this.formShopList.current = val;
      this.getShopList();
    },
  },
};
</script>

<style scoped lang="scss">
.Notetake {
  cursor: pointer;
  color: #7f85e9;
  &:hover {
    color: #7b61ff;
  }
}
.topTis {
  display: flex;
  align-items: baseline;
  color: #333;
  font-size: 14px;
  background: #f4f7ff;
  margin: 24px;
  padding: 12px;
  color: #333;
  margin-left: 0px;
  .desc {
    line-height: 20px;
  }
  p {
    margin-left: 5px;
    line-height: 20px;
  }
  .topTis_line {
    line-height: 25px;
    font-size: 12px;
  }
}
.cancel {
  width: 164px;
  // margin-right: 8px;
  color: #7b61ff;
  border: 1px solid #7b61ff;
  background: rgba(123, 97, 255, 0.1);
  // &:hover {
  //   color: #7b61ff;
  //   border: 1px solid #7b61ff;
  //   background: rgba(123, 97, 255, 0.1);
  // }
}
</style>
